import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
	SupabaseService
} from '@app/core/services';
// ** service
import { LayoutService } from '@app/core/services/layout.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// ** rxjs
import { finalize, map, switchMap, tap, catchError } from 'rxjs/operators';
import { of, Observable, from, EMPTY } from 'rxjs';
import * as moment from 'moment';
import { MessageService } from '@app/core/services';
import { Router } from '@angular/router';

@Component({
	selector: 'app-sign-up',
	templateUrl: './sign-up.component.html',
	styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent {
	isBrowser: boolean;

	mode = 'list'; // list || detail || success
	buyerForm: FormGroup = this.formBuilder.group({
		name: ['', Validators.required],
		nickName: [''],
		email: ['', [Validators.required, Validators.email]],
		phone: ['', Validators.required],
		bankAccount: ['', Validators.required],
		'711Name': ['', Validators.required],
		pwd: ['']
	});

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId,
		private supabaseService: SupabaseService,
		private formBuilder: FormBuilder,
		public layoutService: LayoutService,
		public messageService: MessageService,
		private router: Router
	) {
		this.layoutService.setPageLoading(false);
	}

	// 按下註冊
	register() {
		of(null)
			.pipe(
				tap(() => this.layoutService.setPageLoading(true)),
				switchMap(() => this.register$(this.buyerForm.value.email, this.buyerForm.value.pwd)),
				// tap((res) => {console.log(res)}),
				switchMap((registerRes) => {
					// 移除 pwd
					const { pwd, ...userRequest } = this.buyerForm.value;
					return this.createUser$({
						id: registerRes.user.id,
						...userRequest
					}).pipe(
						map(() => registerRes)
					);
				}),
				finalize(() => this.layoutService.setPageLoading(false))
			)
			.subscribe({
				next: (res) => {
					console.log('subscribe', res);
					this.messageService.add({
						severity: 'success',
						summary: `成功`,
						detail: '註冊成功，請至信箱收取驗證信件，將倒轉至登入頁',
						icon: 'bounce animated',
						life: 5000,
					});
					setTimeout(() => {
						this.router.navigate(['/signIn']);
					}, 3000)
				},
				error: (err) => {
					switch(err.code) {
						case '5269':
							this.messageService.add({
								severity: 'error',
								summary: `錯誤`,
								detail: '此電子郵件已被註冊使用',
								icon: 'bounce animated',
								life: 5000,
							});
							break;
						case '23505':
							this.messageService.add({
								severity: 'error',
								summary: `錯誤`,
								detail: '此帳號已被註冊，請至信箱點擊驗證連結',
								icon: 'bounce animated',
								life: 5000,
							});
							break;
						default:
							this.messageService.add({
								severity: 'error',
								summary: `錯誤`,
								detail: '請聯絡大阿姨團隊',
								icon: 'bounce animated',
								life: 5000,
							});
							break;
					}
				}
			});
	}

	getCreateUserRequest() {
		const { pwd, ...request } = this.buyerForm.value;
		return request;
	}

	// --------------------------- API ---------------------------
	// - 註冊
	register$(email: string, pwd: string): Observable<any> {
		return from(this.supabaseService.signUp(email, pwd)).pipe(
			map(({ data, error }) => {
				if (error) throw error;
				// 判斷此信箱是否已註冊過
				if (data?.user && (!data.user.identities || data.user.identities.length === 0)) {
					// throw new Error('EMAIL_ALREADY_EXISTS');
					throw {
						code: '5269',
						message: 'EMAIL_ALREADY_EXISTS',
						source: 'register'
					};
				}
				return data;
			})
		);
	}

	// - 建立使用者
	createUser$(userInfo: any): Observable<any> {
		return from(this.supabaseService.createUser(userInfo)).pipe(
			map(({ data, error }) => {
				if (error) throw error;
				return data;
			})
		);
	}

}
